export enum TemporalRegistration{
    ORDINARY = 'ORDINARY',
    EXTRAORDINARY = 'EXTRAORDINARY',
    UNDEFINED = 'UNDEFINED'
}